interface Props {
  label: string;
  value: string | number;
  hint?: string;
  tone?: "default" | "ok" | "warn" | "err";
}

const TONE_CLASS: Record<NonNullable<Props["tone"]>, string> = {
  default: "text-mesh-ink",
  ok: "text-mesh-ok",
  warn: "text-mesh-warn",
  err: "text-mesh-err",
};

export default function Stat({ label, value, hint, tone = "default" }: Props) {
  return (
    <div className="bg-mesh-panel rounded-lg p-4 flex flex-col gap-1">
      <div className="text-xs uppercase tracking-wider text-mesh-mute">
        {label}
      </div>
      <div className={`text-2xl font-bold ${TONE_CLASS[tone]}`}>{value}</div>
      {hint && <div className="text-xs text-mesh-mute">{hint}</div>}
    </div>
  );
}
